// extracted by mini-css-extract-plugin
export default {"navbarContainer":"NavBar_navbarContainer__szmdg","spanContainer":"NavBar_spanContainer__F2Tag"};